import { BasePeerToPeerCampaignAction } from "./BasePeerToPeerCampaignAction";

import { FormButton } from "@/forms-design-system/FormButton";
import { useTranslate } from "@/hooks/useTranslate";
import { ArrowDiagonalRight } from "@/icons/outlined";

type PeerToPeerDonateCampaignActionProps = {
  canDonateToTeamCampaign: boolean;
  canDonateToIndividualCampaign: boolean;
  onClick?: () => void;
};

export const PeerToPeerDonateCampaignAction = ({
  canDonateToTeamCampaign,
  canDonateToIndividualCampaign,
  onClick,
}: PeerToPeerDonateCampaignActionProps) => {
  const { t } = useTranslate();

  const getDescription = () => {
    if (canDonateToTeamCampaign) {
      return canDonateToIndividualCampaign
        ? t("donationForm", "peerToPeer.description.giveToIndividualTeamOrCampaign")
        : t("donationForm", "peerToPeer.description.giveToTeamOrCampaign");
    }
    return canDonateToIndividualCampaign
      ? t("donationForm", "peerToPeer.description.giveToIndividualOrCampaign")
      : t("donationForm", "peerToPeer.description.giveToCampaign");
  };

  return (
    <BasePeerToPeerCampaignAction
      title={t("donationForm", "peerToPeer.title.wantToDonate")}
      description={getDescription()}
      slots={{
        button: (
          <FormButton
            variant="solid"
            endIcon={<ArrowDiagonalRight />}
            onClick={onClick}
            data-test="donate-button"
            sx={{
              whiteSpace: "nowrap",
            }}
          >
            {t("donationForm", "peerToPeer.button.donate")}
          </FormButton>
        ),
      }}
    />
  );
};
